import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Card } from "../../components/ui/card";
import { mediaSrc } from "../../components/MediaPicker";
import { Megaphone } from "lucide-react";
import { timeAgo } from "../../lib/channels";

const CLS = { onemli: "border-rose-200 bg-rose-50", uyari: "border-amber-200 bg-amber-50", bilgi: "border-blue-200 bg-blue-50" };
export default function TechAnnouncements() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/announcements/active").then((r) => { setList(r.data); r.data.filter((a) => !a.read).forEach((a) => api.post(`/announcements/${a.id}/read`).catch(() => {})); }); }, []);
  return (
    <div className="space-y-3" data-testid="tech-announcements-page">
      <h1 className="font-display text-2xl font-bold text-slate-900">Duyurular</h1>
      {list.length === 0 && <Card className="p-10 text-center border-slate-200 shadow-none text-slate-500"><Megaphone className="h-10 w-10 mx-auto text-slate-300 mb-2" />Duyuru yok</Card>}
      {list.map((a) => (
        <Card key={a.id} className={`p-4 shadow-none border ${CLS[a.level] || CLS.bilgi}`} data-testid={`tech-an-${a.id}`}>
          <div className="font-semibold text-slate-900">{a.title}</div>
          <div className="text-[11px] text-slate-500 mb-2">{timeAgo(a.created_at)}</div>
          {a.image_url && <img src={mediaSrc(a.image_url)} alt="" className="rounded-lg w-full mb-2" />}
          {a.body && <div className="text-sm whitespace-pre-wrap text-slate-700">{a.body}</div>}
        </Card>
      ))}
    </div>
  );
}
